// // src/path/to/pollData.js

// import polls_image from "../../../../../assets/images/polls_image.png";

// const pollData = [
//   {
//     question: "In which year did the Dayton Flyers reach the NCAA Final Four?",
//     options: ["2021", "2022", "2023", "2024"],
//     image: polls_image,
//     // correctAnswer: "2022",
//   },
//   {
//     question: "Who is the all-time leading scorer for the Dayton Flyers?",
//     options: [" Brian Roberts", "Roosevelt Chapman", "Anthony Grant", "Steve McElvene"],
//     image: polls_image, // Again, you can use different images here
//     // correctAnswer: "Roosevelt Chapman",
//   },
//   {
//     question: "Who won the NBA championship in 2020?",
//     options: ["Los Angeles Lakers", "Miami Heat", "Toronto Raptors", "Golden State Warriors"],
//     image: polls_image, // You can change the image path for each question
//     // correctAnswer: "Miami Heat",
//   },
//   // Add more questions as needed
// ];

// export default pollData;

// const pollData = [
//   {
//     question: "In which year did the Dayton Flyers reach the NCAA Final Four?",
//     options: [
//       {label: "2021",votes: 10, percentage: 10,},
//       {label: "2022",votes: 20, percentage: 30,},
//       {label: "2023",votes: 30, percentage: 40,},
//       {label: "2024",votes: 40, percentage: 50,},
//     ]
//   }
// ]

// export default pollData
// src/path/to/pollData.js

import polls_image from "../../../../../assets/images/polls_image.png";
import { POLL_VOTEDFOR } from "../../../../../lib/constants/globalConstant";

const pollData = [
  {
    question: "In which year did the Dayton Flyers reach the NCAA Final Four?",
    options: [
      { label: "2021", votes: 120 }, 
      { label: "2022", votes: 200 }, 
      { label: "2023", votes: 50 }, 
      { label: "2024", votes: 30 }
    ],
    image: polls_image,
    isAttempted: false,
  },
  {
    question: "Who is the all-time leading scorer for the Dayton Flyers?",
    options: [
      { label: "Brian Roberts", votes: 150 },
      { label: "Roosevelt Chapman", votes: 180 },
      { label: "Anthony Grant", votes: 30 },
    ],
    image: polls_image, // You can use different images here
  },
  {
    question: "Will Dayton Flyers win the NBA championship in 2025?",
    options: [
      { label: "Yes", votes: 220 },
      { label: "No", votes: 100 },
    ],
    image: polls_image, // You can change the image path for each question
  },
  // Add more questions as needed
];

export default pollData;

export const isAttemptedPoll = (options, userId, gameId = null) => {
  // Determine if we're checking for game context or season context
  const votedFor = gameId ? POLL_VOTEDFOR.GAME : POLL_VOTEDFOR.SEASON; 
  
  // Check if the user has voted in the specified context
  return options?.some(option => 
    option?.voteDetails?.length && option?.voteDetails?.some(vote => 
      vote?.userIds?.some(_userId => _userId === userId) && 
      vote?.votedFor === votedFor && 
      (votedFor === POLL_VOTEDFOR.SEASON || (votedFor === POLL_VOTEDFOR.GAME && vote.gameId && vote.gameId === gameId))
    )
  );
};